import { useEffect, useState } from 'react';
import { fetchAuthenticatedBlobUrl } from '../../../utils/blobs';

interface Props {
  url: string;
  alt: string;
  className?: string;
}

export function AuthenticatedImage({ url, alt, className }: Props) {
  const [src, setSrc] = useState<string | null>(null);

  useEffect(() => {
    let revoked = false;
    let blobUrl: string | null = null;
    fetchAuthenticatedBlobUrl(url)
      .then((u) => {
        if (revoked) {
          URL.revokeObjectURL(u);
          return;
        }
        blobUrl = u;
        setSrc(u);
      })
      .catch(() => {
        if (!revoked) {
          setSrc(null);
        }
      });
    return () => {
      revoked = true;
      if (blobUrl) {
        URL.revokeObjectURL(blobUrl);
      }
    };
  }, [url]);

  if (!src) {
    return <div className={className} aria-label="Carregando imagem" />;
  }
  return <img src={src} alt={alt} className={className} />;
}
